// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3Z3up","large":"styles_large__k8qgE"};